import { useMemo } from 'react'

import { BROWSER_MAX_URL_LENGTH, SAFE_MAX_URL_LENGTH } from 'src/utils/constants/browserUrlLength'
import useGetCurrentUrl from './useGetCurrentUrl'
import useNavigatorDetect, { BrowserType } from './useNavigatorDetect'

const BROWSER_MAX_LENGTH_MAP: Record<BrowserType, number> = {
  chrome: BROWSER_MAX_URL_LENGTH.CHROME,
  firefox: BROWSER_MAX_URL_LENGTH.FIREFOX,
  safari: BROWSER_MAX_URL_LENGTH.SAFARI,
  ie: BROWSER_MAX_URL_LENGTH.INTERNET_EXPLORER,
  edge: BROWSER_MAX_URL_LENGTH.CHROME,
  unknown: SAFE_MAX_URL_LENGTH,
}

const useIsValidUrlLength = () => {
  const url = useGetCurrentUrl()
  const browser = useNavigatorDetect()

  const isValidUrlLength = useMemo(() => {
    const maxLength = BROWSER_MAX_LENGTH_MAP[browser]
    return url.length <= maxLength
  }, [url, browser])

  return isValidUrlLength
}

export default useIsValidUrlLength
